import { Button } from "rsuite";
import styled from "styled-components";

const PrimaryButton = styled(Button)`
    && {
        background-color: var(--color-button);
        color: var(--color-text);
        border: none;
        border-radius: 4px;
        padding: 0.5rem 1rem;
        gap: 0.5rem;
        transition: transform 0.1s ease, box-shadow 0.1s ease;

        font-family: "Noto Sans", sans-serif;
        font-optical-sizing: auto;
        font-weight: 600;
        font-style: normal;
    }

    &&:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px var(--color-button-hover);
    }

    &&:active {
        transform: translateY(0);
        box-shadow: none;
    }

    &&:disabled {
        background-color: var(--color-button-hover);
        color: var(--color-text-dark);
    }

    &&:hover:disabled {
        transform: none;
        box-shadow: none;
    }
`;

export default PrimaryButton;